/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-imports */
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Collapse,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core';
import { Add, Chat, ExpandLess, ExpandMore, Send } from '@material-ui/icons';

import { FormatDate } from 'components';
import { budgetService } from 'services/budget';

import { useBudget } from '../../context/BudgetContext';
import { useStyles } from './styles';

export default function BudgetObservations() {
  const classes = useStyles();
  const { budget } = useBudget();

  const [expanded, setExpanded] = useState(() => {
    const saved = localStorage.getItem('budgetObservationsListExpanded');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const [observations, setObservations] = useState([]);
  const [loadingObservations, setLoadingObservations] = useState(false);
  const [newObservation, setNewObservation] = useState('');
  const [savingObservation, setSavingObservation] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);

  useEffect(() => {
    localStorage.setItem('budgetObservationsListExpanded', JSON.stringify(expanded));
  }, [expanded]);

  useEffect(() => {
    if (budget?.budget?.id) {
      loadObservations();
    }
  }, [budget?.budget?.id]);

  const loadObservations = async () => {
    if (!budget?.budget?.id) return;

    setLoadingObservations(true);
    try {
      const response = await budgetService.getBudgetObservations(budget.budget.id);
      setObservations(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar observações:', error);
      toast.error('Erro ao carregar observações do orçamento');
    } finally {
      setLoadingObservations(false);
    }
  };

  const handleSaveObservation = async () => {
    if (!newObservation.trim()) {
      toast.warning('Digite uma observação antes de salvar');
      return;
    }

    if (!budget?.budget?.id) {
      toast.error('Orçamento não encontrado');
      return;
    }

    setSavingObservation(true);
    try {
      await budgetService.saveBudgetObservation({
        budgetId: budget.budget.id,
        observation: newObservation.trim(),
      });

      toast.success('Observação salva com sucesso!');
      setNewObservation('');
      setShowAddForm(false);
      await loadObservations();
    } catch (error) {
      console.error('Erro ao salvar observação:', error);
      toast.error(error?.response?.data?.message || 'Erro ao salvar observação. Tente novamente.');
    } finally {
      setSavingObservation(false);
    }
  };

  return (
    <Card className={classes.card}>
      <CardContent>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          style={{ cursor: 'pointer', marginBottom: 16 }}
          onClick={() => setExpanded(!expanded)}
        >
          <Box display='flex' alignItems='center'>
            <Chat color='primary' style={{ marginRight: 8 }} />
            <Typography variant='h6' className={classes.title}>
              📝 Observações do Orçamento
            </Typography>
            {observations.length > 0 && (
              <Box
                style={{
                  backgroundColor: '#2196f3',
                  color: 'white',
                  borderRadius: 12,
                  padding: '2px 8px',
                  marginLeft: 8,
                  fontSize: '0.75rem',
                  fontWeight: 600,
                }}
              >
                {observations.length}
              </Box>
            )}
          </Box>
          <IconButton size='small'>{expanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
        </Box>

        <Collapse in={expanded}>
          {loadingObservations ? (
            <Box display='flex' justifyContent='center' padding={3}>
              <CircularProgress size={30} />
            </Box>
          ) : (
            <>
              <Box marginBottom={2}>
                {observations.length === 0 ? (
                  <Box
                    padding={3}
                    style={{
                      backgroundColor: '#f5f5f5',
                      borderRadius: 8,
                      border: '1px dashed #ccc',
                      textAlign: 'center',
                    }}
                  >
                    <Typography variant='body2' style={{ color: '#999' }}>
                      Nenhuma observação registrada ainda
                    </Typography>
                  </Box>
                ) : (
                  <Box>
                    {observations.map((obs, index) => (
                      <Box
                        key={obs.idContato || index}
                        padding={2}
                        marginBottom={1}
                        style={{
                          backgroundColor: '#f9f9f9',
                          borderRadius: 8,
                          border: '1px solid #e0e0e0',
                        }}
                      >
                        <Typography
                          variant='caption'
                          style={{
                            color: '#666',
                            display: 'block',
                            marginBottom: 4,
                            fontWeight: 600,
                          }}
                        >
                          <FormatDate>{obs.dt_contato}</FormatDate>
                        </Typography>
                        <Typography
                          variant='body2'
                          style={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                          }}
                        >
                          {obs.obs}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>

              {!showAddForm ? (
                <Button
                  fullWidth
                  variant='outlined'
                  color='primary'
                  startIcon={<Add />}
                  onClick={() => setShowAddForm(true)}
                >
                  Adicionar Observação
                </Button>
              ) : (
                <Box
                  padding={2}
                  style={{
                    backgroundColor: '#e3f2fd',
                    borderRadius: 8,
                    border: '1px solid #2196f3',
                  }}
                >
                  <Typography
                    variant='subtitle2'
                    style={{ marginBottom: 8, fontWeight: 600, color: '#1976d2' }}
                  >
                    Nova Observação
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    variant='outlined'
                    placeholder='Digite sua observação aqui...'
                    value={newObservation}
                    onChange={(e) => setNewObservation(e.target.value)}
                    disabled={savingObservation}
                    style={{ backgroundColor: 'white', marginBottom: 12 }}
                  />
                  <Box display='flex' style={{ gap: 8 }}>
                    <Button
                      variant='contained'
                      color='primary'
                      startIcon={
                        savingObservation ? (
                          <CircularProgress size={16} color='inherit' />
                        ) : (
                          <Send />
                        )
                      }
                      onClick={handleSaveObservation}
                      disabled={savingObservation || !newObservation.trim()}
                    >
                      {savingObservation ? 'Salvando...' : 'Salvar'}
                    </Button>
                    <Button
                      variant='outlined'
                      onClick={() => {
                        setShowAddForm(false);
                        setNewObservation('');
                      }}
                      disabled={savingObservation}
                    >
                      Cancelar
                    </Button>
                  </Box>
                </Box>
              )}
            </>
          )}
        </Collapse>
      </CardContent>
    </Card>
  );
}
